export const available = [
  {
    name: 'В наличии',
    id: 'AVAILABLE',
  },
  {
    name: 'Нет в наличии',
    id: 'NOT_AVAILABLE',
  },
  {
    name: 'Под заказ',
    id: 'ORDER',
  },
]
